import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin/AdminShell";
import { AdminLoansPage } from "@/components/admin/loans/AdminLoansPage";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin_/loans")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: () => (
    <AdminShell page="loans">
      <AdminLoansPage />
    </AdminShell>
  ),
});
